
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

interface CustomerTableProps {
  customers: any[];
  onViewDetails: (customer: any) => void;
}

export function CustomerTable({ customers, onViewDetails }: CustomerTableProps) {
  return (
    <Card>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Nome</TableHead>
              <TableHead>Contato</TableHead>
              <TableHead>Plataforma</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Total Gasto</TableHead>
              <TableHead>Saldo Cashback</TableHead>
              <TableHead className="text-right">Ações</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {customers.map((customer) => (
              <TableRow key={customer.id}>
                <TableCell className="font-medium">
                  {customer.name}
                  <div className="text-xs text-gray-500">
                    {customer.orders_count || customer.purchases || 0} pedidos
                  </div>
                </TableCell>
                <TableCell>
                  <div>{customer.email}</div>
                  <div className="text-xs text-gray-500">{customer.phone}</div>
                </TableCell>
                <TableCell>
                  <Badge variant="outline" className="capitalize">
                    {customer.platform || 'nuvemshop'}
                  </Badge>
                  {customer.store_id && (
                    <div className="text-xs text-gray-500 mt-1">
                      Loja: {customer.store_id}
                    </div>
                  )}
                </TableCell>
                <TableCell>
                  <Badge 
                    variant={customer.status === 'active' ? 'default' : 'secondary'}
                    className="capitalize"
                  >
                    {customer.status || 'active'}
                  </Badge>
                </TableCell>
                <TableCell>
                  {customer.totalSpent || customer.total_spent || 0} {customer.total_spent_currency || 'BRL'}
                  <div className="text-xs text-gray-500">
                    Último pedido: {
                      customer.last_order_date 
                        ? new Date(customer.last_order_date).toLocaleDateString('pt-BR')
                        : customer.lastPurchaseDate || 'N/A'
                    }
                  </div>
                </TableCell>
                <TableCell>
                  <div className="font-medium text-green-600">
                    {customer.cashbackBalance || 'R$ 0,00'}
                  </div>
                  <div className="text-xs text-gray-500">
                    Cupons válidos
                  </div>
                </TableCell>
                <TableCell className="text-right">
                  <Button 
                    variant="ghost" 
                    size="sm" 
                    onClick={() => onViewDetails(customer)}
                    className="font-medium text-brand-blue"
                  >
                    Ver Detalhes
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
